function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M362.666667 192m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z",
  "p-id": 2853
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M661.333333 192m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z",
  "p-id": 2854
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M362.666667 512m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z",
  "p-id": 2855
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M661.333333 512m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z",
  "p-id": 2856
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M362.666667 832m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z",
  "p-id": 2857
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M661.333333 832m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z",
  "p-id": 2858
});

function SvgDrag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1655944605849,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2852,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.66585abf.svg";
export { ForwardRef as ReactComponent };